import styled from 'styled-components';

const SCPageTitle = styled.span`
  font-size: 22px;
  font-weight: bold;
  border-bottom: 3px solid ${p => p.theme.color.blueLight};

  @media (${p => p.theme.mq.desktop}) {
    font-size: 28px;
    text-align: left;
    border: none;
  }
`;

export default SCPageTitle;



// WEBPACK FOOTER //
// ./src/components/PageTitle/styles.js